// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
// components
import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';
import { VERIFICATION_EMAIL } from 'src/config-contact';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Các ngành đào tạo',
    children: [
      { name: 'Y Khoa', href: 'https://tuyensinh.ttu.edu.vn/khoa-y/' },
      { name: 'Điều dưỡng', href: 'https://tuyensinh.ttu.edu.vn/dieu-duong/' },
      { name: 'Kỹ thuật Xét nghiệm', href: 'https://tuyensinh.ttu.edu.vn/ky-thuat-xet-nghiem-y-hoc/' },
      { name: 'Khoa Học Máy Tính', href: 'https://tuyensinh.ttu.edu.vn/khoa-hoc-may-tinh/' },
      { name: 'Ngôn Ngữ Anh', href: 'https://tuyensinh.ttu.edu.vn/ngon-ngu-anh/' },
      { name: 'Công Nghệ Sinh Học', href: 'https://tuyensinh.ttu.edu.vn/cong-nghe-sinh-hoc/' },
      { name: 'Kinh Doanh Quốc tế', href: 'https://tuyensinh.ttu.edu.vn/kinh-doanh-quoc-te/' },
      { name: 'Quản trị kinh doanh', href: 'https://tuyensinh.ttu.edu.vn/quan-tri-kinh-doanh/' },
      { name: 'Kế toán', href: 'https://tuyensinh.ttu.edu.vn/ke-toan/' },
      { name: 'Tài chính – Ngân hàng', href: 'https://tuyensinh.ttu.edu.vn/tai-chinh-ngan-hang/' },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.neutral',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={5}>
          <Typography
              variant="h5"
              sx={{
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              Đại Học Tân Tạo
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              Địa chỉ: Đại lộ Đại học Tân Tạo, E.City Tân Đức, Đức Hoà, Long An<br />
              Điện thoại: (+84) 272 377 5995 - (+84) 0981 152 153<br />
              Email: tuyensinh@ttu.edu.vn<br />
              <Stack component="span" direction="row" spacing={0.5} alignItems="center" sx={{ fontWeight: 700, color: 'primary.main' }}>
                Xác minh văn bằng:
                <Link href={`mailto:${VERIFICATION_EMAIL}`} sx={{ fontWeight: 700, color: 'primary.main' }}>
                  {VERIFICATION_EMAIL}
                </Link>
              </Stack>
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  component={RouterLink}
                  href={social.path}
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                >
                  <Iconify color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={7}>
            <Stack spacing={0} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={.5}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                      target="_blank"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
              <Stack
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    Bản đồ
                  </Typography>
                  <iframe title="ban do ttu" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.245651167569!2d106.4397433146529!3d10.792488261848522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310ad3f703fc2821%3A0xd03984a57f051ab8!2sTan+Tao+University!5e0!3m2!1sen!2s!4v1482826842333" width="100%" height="250" frameBorder="0" allowFullScreen />
                </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          Copyright © 2024 Tan Tao University. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}
